<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Comprador"
              :roles="['ROLE_COMPRADOR']"
              class="rounded-tag-small"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                              class="rounded-tag-small"
                                              show-details
                                              dense
                                              base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-fornecedor-multiple
              class="rounded-tag-small"
              dense
              search-in-compra
              search-by-codigo-interno
              v-model="localFornecedor"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Solicitantes"
              :roles="['ROLE_REQUISICAO']"
              class="rounded-tag-small"
              v-model="localSolicitante"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <v-switch dense
                      hide-details
                      class="switch-dense"
                      v-model="localFilterBySaving"
                      label="Somente compras com saving"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {},
  data: () => ({
    menuOpened: false,
    localEmpresa: null,
    localCentroCusto: [],
    localProduto: [],
    localProjeto: [],
    localResponsavel: [],
    localGrupo: [],
    localFornecedor: [],
    localSolicitante: [],
    localFilterBySaving: false,
  }),
  computed: {
    ...mapGetters('indicadoresCompras', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    empresa: {
      get() {
        return this.$store.getters['indicadoresCompras/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('indicadoresCompras/empresa', empresa);
      },
    },
    centroCusto: {
      get() {
        return this.$store.getters['indicadoresCompras/centroCusto'];
      },
      set(centroCusto) {
        this.$store.dispatch('indicadoresCompras/centroCusto', centroCusto);
      },
    },
    produto: {
      get() {
        return this.$store.getters['indicadoresCompras/produto'];
      },
      set(produto) {
        this.$store.dispatch('indicadoresCompras/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['indicadoresCompras/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('indicadoresCompras/projeto', projeto);
      },
    },
    responsavel: {
      get() {
        return this.$store.getters['indicadoresCompras/responsavel'];
      },
      set(responsavel) {
        this.$store.dispatch('indicadoresCompras/responsavel', responsavel);
      },
    },
    filterBySaving: {
      get() {
        return this.$store.getters['indicadoresCompras/filterBySaving'];
      },
      set(filterBySaving) {
        this.$store.dispatch('indicadoresCompras/filterBySaving', filterBySaving);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['indicadoresCompras/grupo'];
      },
      set(grupo) {
        this.$store.dispatch('indicadoresCompras/grupo', grupo);
      },
    },
    fornecedor: {
      get() {
        return this.$store.getters['indicadoresCompras/fornecedor'];
      },
      set(fornecedor) {
        this.$store.dispatch('indicadoresCompras/fornecedor', fornecedor);
      },
    },
    solicitante: {
      get() {
        return this.$store.getters['indicadoresCompras/solicitante'];
      },
      set(solicitante) {
        this.$store.dispatch('indicadoresCompras/solicitante', solicitante);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.centroCusto = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.responsavel = this.localResponsavel;
      this.filterBySaving = this.localFilterBySaving;
      this.grupo = this.localGrupo;
      this.fornecedor = this.localFornecedor;
      this.solicitante = this.localSolicitante;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localGrupo = null;
      this.localFilterBySaving = false;
      this.localFornecedor = null;
      this.localSolicitante = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localCentroCusto = this.centroCusto || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.responsavel || [];
    this.localFilterBySaving = this.filterBySaving || false;
    this.localGrupo = this.grupo || [];
    this.localFornecedor = this.fornecedor || [];
    this.localSolicitante = this.solicitante || [];
  },
};
</script>
